//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";
import BackendServices from "@/services/backend-services.js";
import OrderTable from "@/pages/AutomaticOrder/components/OrderTable.vue";
import OrderForm from "@/pages/AutomaticOrder/components/OrderForm.vue";
import moment from "moment";
import { Feedback } from "@/utils/notify-toaster.js";
import { EventBus } from "@/event-bus.js";
import { fileNameFromContent } from "@/utils/name-parser.js";
// import RightDrawer from "@/components/RightDrawer/Filters.vue";

const EMPTY_ORDER = {
  date: null,
  retailer: {
    code: null,
    desc: null,
  },
  warehouse: null,
  flow: null,
  status: null,
  ean: null,
  internalCode: null,
  store: {
    allocation: null,
    code: null,
    name: null,
  },
  seller: null,
  deliveryDate: null,
  orderAmount: null,
  salesUnit: null,
  orderReason: null,
};

const CONFIG_TABLE_COLUMNS = [
  // {
  //   name: "store",
  //   required: true,
  //   label: "Loja",
  //   align: "left",
  //   field: row => row.store,
  //   sortable: false
  // },
  // {
  //   name: "product",
  //   required: true,
  //   label: "Produto",
  //   align: "left",
  //   field: row => row.product,
  //   sortable: false
  // },
  // {
  //   name: "minimumStock",
  //   required: true,
  //   label: "Stock mínimo",
  //   align: "left",
  //   field: row => row.stock.minimum,
  //   sortable: false
  // },
  // {
  //   name: "suggestedStock",
  //   required: true,
  //   label: "Stock sugerido",
  //   align: "left",
  //   field: row => row.stock.maximum,
  //   sortable: false
  // }
];

const TABLE_LIST_COLUMNS = [
  {
    name: "date",
    required: false,
    label: "Data de referência",
    align: "left",
    field: (row) => row.order_date,
    sortable: false,
  },
  {
    name: "retailer-code",
    required: false,
    label: "Código Retalhista",
    align: "left",
    field: (row) => (row.retailer_info ? row.retailer_info.sku : null),
    sortable: false,
  },
  {
    name: "retailer-description",
    required: false,
    label: "Descrição Retalhista",
    align: "left",
    field: (row) => (row.retailer_info ? row.retailer_info.name : null),
    sortable: false,
  },
  {
    name: "warehouse",
    required: false,
    align: "left",
    label: "Armazém",
    field: (row) => row.warehouse,
    sortable: false,
  },
  {
    name: "flow",
    required: false,
    label: "Fluxo",
    align: "left",
    field: (row) => row.flux,
    sortable: false,
  },
  {
    name: "status",
    required: false,
    label: "Estado",
    align: "left",
    field: (row) => row.status,
    sortable: false,
    icon: {
      conditional: true,
      0: {
        name: "mdi-close-circle-outline",
        label: "Inactivo",
        color: "red-4",
      },
      1: {
        name: "mdi-check-circle-outline",
        label: "Activo",
        color: "green-4",
      },
    },
  },
  {
    name: "ean",
    required: false,
    label: "EAN",
    align: "left",
    field: (row) => (row.product ? row.product.ean : null),
    sortable: false,
  },
  {
    name: "internal-code",
    required: false,
    label: "Código interno",
    align: "left",
    field: (row) => (row.product ? row.product.sku : null),
    sortable: false,
  },
  {
    name: "store-allocation",
    required: false,
    label: "Alocação de loja",
    align: "left",
    field: (row) => row.store_allocation,
    sortable: false,
  },
  {
    name: "store-code",
    required: false,
    label: "Código de loja",
    align: "left",
    field: (row) => (row.store ? row.store.code : null),
    sortable: false,
  },
  {
    name: "store-name",
    required: false,
    label: "Nome de loja",
    align: "left",
    field: (row) => (row.store ? row.store.name : null),
    sortable: false,
  },
  {
    name: "seller",
    required: false,
    label: "Vendedor",
    align: "left",
    field: (row) => row.vendor,
    sortable: false,
  },
  {
    name: "delivery-date",
    required: false,
    label: "Data de entrega",
    align: "left",
    field: (row) => row.delivery_date,
    sortable: false,
  },
  {
    name: "order-amount",
    required: false,
    label: "Quantidade a encomendar",
    align: "left",
    field: (row) => row.order_quantity,
    sortable: false,
  },
  {
    name: "sales-unit",
    required: false,
    label: "Unidade de venda",
    align: "left",
    field: (row) => row.sale_unit,
    sortable: false,
  },
  {
    name: "order-reason",
    required: false,
    label: "Motivo da encomenda",
    align: "left",
    field: (row) => row.order_reason,
    sortable: false,
  },
];

export default {
  name: "AutomaticOrder",
  components: {
    OrderTable,
    OrderForm,
    Table,
  },
  props: {
    executeQuery: {
      type: Boolean,
    },
  },
  mounted: function () {
    this.isLoading = true;
    let date = new Date();
    let drawerParams = {
      filter: {
        reference_date: moment(date).format("YYYY-MM-DD"),
      },
    };
    this.$store.commit("setSingleDate", drawerParams.filter.reference_date);
    BackendServices.getAutoOrderItems(null, drawerParams).then((response) => {
      this.recordsTotal = response.headers["x-total-count"];
      if (response.headers["x-total-count"] > 0) {
        this.tableData = response.data;
      } else {
        this.tableData = [];
      }
      this.isLoading = false;
    });
    this.$store.commit("setDatePickerState", true);
    EventBus.$on("rightDrawerQueryAction", this.executeQuertAction);
  },
  data: function () {
    return {
      selected: [],
      tableData: [],
      data: EMPTY_ORDER,
      configData: [],
      filterState: null,
      date: null,
      productHierarchyElementId: null,
      storeHierarchyElementId: null,
      geoHierarchyElementId: null,
      productIds: null,
      storeIds: null,
      minimumStock: null,
      maximumStock: null,
      configColumns: CONFIG_TABLE_COLUMNS,
      tableColumns: TABLE_LIST_COLUMNS,
      configRecordsTotal: null,
      recordsTotal: null,
      isLoading: false,
      formOpen: false,
      editRowClicked: false,
      employee_id: null,
    };
  },
  methods: {
    executeQuertAction: function () {
      this.askForData();
    },
    renderRightSide: function (event) {
      this.editRowClicked = true;
      this.data = event;
    },
    expandDrawer: function () {
      this.seamlessLabels = true;
      this.$store.commit("toggleRightDrawer");
    },
    closeForm() {
      this.editRowClicked = false;
    },
    changeValue() {
      for (var i in this.selected) {
        this.selected[i].stock.minimum = this.minimumStock;
        this.selected[i].stock.maximum = this.maximumStock;
      }
    },
    askForFacilitatorData: function (event) {
      this.isLoading = true;
      BackendServices.getAutoOrderFacilitatorItems(
        event.pagination,
        event.filter
      ).then((response) => {
        this.configRecordsTotal = response.headers["x-total-count"];
        this.configData = response.data;
        this.isLoading = false;
      });
    },
    async askForData(event = null) {
      let pagination = null;

      if (event == null) {
        pagination = null;
      } else {
        pagination = {
          page: event.pagination.page,
          rowsPerPage: event.pagination.rowsPerPage,
        };
      }

      this.isLoading = true;

      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          reference_date: this.date._i,
          employee_id: this.employeeIds,
        },
      };

      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }

      let result = await BackendServices.getAutoOrderItems(
        pagination,
        drawerParams
      );
      this.recordsTotal = result.headers["x-total-count"];
      if (result.data.auto_orders != undefined) {
        this.tableData = result.data.auto_orders;
      } else {
        this.tableData = result.data;
      }
      this.isLoading = false;
    },
    async saveAutoOrderEntry() {
      let response = await BackendServices.updateAutoOrderItem(this.data);
      if (response.status == 200) {
        this.tableData.forEach((element) => {
          if (element.id == response.data.id) {
            element.order_quantity = response.data.order_quantity;
          }
        });
        Feedback.success("Encomenda atualizada com sucesso!");
      } else {
        Feedback.error("Erro ao atualizar encomenda!");
      }

      // user response data to update order_quantity in table use this.tableData

      this.editRowClicked = false;
    },
    openModal: function () {
      this.formOpen = true;
      BackendServices.getAutoOrderFacilitatorItems().then((response) => {
        this.configRecordsTotal = response.headers["x-total-count"];
        this.configData = response.data;
        this.isLoading = false;
      });
    },
    downloadCsv: function () {
      this.isLoading = true;
      let object = {
        reference_date: this.date._i,
      };

      BackendServices.downloadRtlAutoOrderCsv(object).then(
        (response) => {
          this.isLoading = false;
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          let fileName = fileNameFromContent(
            response.headers["content-disposition"]
          );
          link.setAttribute("download", fileName); //any other extension
          document.body.appendChild(link);
          link.click();
          this.$q.notify({
            icon: "cloud_download",
            color: "green-4",
            position: "bottom",
          });
          link.remove();
        },
        () => {
          this.$q.notify({
            message: "Erro ao exportar ficheiro com data: " + this.date._i,
            color: "red-4",
          });
          this.isLoading = false;
        }
      );
    },
    exportAutoOrderSupplier: function () {
      this.isLoading = true;
      let object = this.objectBuilder();

      BackendServices.downloadAutoOrderExport(object).then(
        (response) => {
          this.isLoading = false;
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data])
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          let fileName = fileNameFromContent(
            response.headers["content-disposition"]
          );
          link.setAttribute("download", fileName); //any other extension
          document.body.appendChild(link);
          link.click();
          this.$q.notify({
            icon: "cloud_download",
            color: "green-4",
            position: "bottom",
          });
          link.remove();
        },
        () => {
          this.$q.notify({
            message: "Erro ao exportar ficheiro com data: " + this.date._i,
            color: "red-4",
          });
          this.isLoading = false;
        }
      );
    },
    objectBuilder: function () {
      let drawerParams = {
        filter: {
          "product.least_hierarchy_level_id": this.productHierarchyElementId,
          "product.id": this.productIds,
          "store.least_hierarchy_level_id": this.storeHierarchyElementId,
          "store.id": this.storeIds,
          "store.least_geo_level_id": this.geoHierarchyElementId,
          reference_date: this.date._i,
          employee_id: this.employeeIds,
        },
      };

      for (let key in drawerParams.filter) {
        if (
          drawerParams.filter[key] === null ||
          drawerParams.filter[key] === undefined
        ) {
          delete drawerParams.filter[key];
        }
      }

      return drawerParams;
    },
  },
  watch: {
    executeQuery(val) {
      if (val) {
        this.askForData();
      }
    },
    "$store.getters.getProductHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let productHierarchy = Object.values(
          this.$store.getters.getProductHierarchy
        ).filter((i) => i.length > 0);
        this.productHierarchyElementId =
          productHierarchy[productHierarchy.length - 1];
      },
    },
    "$store.getters.getStoreHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let storeHierarchy = Object.values(
          this.$store.getters.getStoreHierarchy
        ).filter((i) => i.length > 0);
        this.storeHierarchyElementId =
          storeHierarchy[storeHierarchy.length - 1];
      },
    },
    "$store.getters.getGeographyHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let geoHierarchy = Object.values(
          this.$store.getters.getGeographyHierarchy
        ).filter((i) => i.length > 0);
        this.geoHierarchyElementId = geoHierarchy[geoHierarchy.length - 1];
      },
    },
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.productIds) {
          this.productIds = [];
        }
        if (this.$store.getters.getProductList.length) {
          this.productIds.splice(
            0,
            this.productIds.size,
            ...this.$store.getters.getProductList
          );
        } else {
          this.productIds = null;
        }
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.storeIds) {
          this.storeIds = [];
        }

        if (this.$store.getters.getStoreList.length) {
          this.storeIds.splice(
            0,
            this.storeIds.size,
            ...this.$store.getters.getStoreList
          );
        } else {
          this.storeIds = null;
        }
      },
    },
    "$store.getters.getSingleDate": {
      immediate: true,
      deep: true,
      handler: function () {
        this.date = moment(this.$store.getters.getSingleDate, "YYYY/MM/DD");
      },
    },
    "$store.getters.getEmployeeList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.employeeIds) {
          this.employeeIds = [];
        }

        if (this.$store.getters.getEmployeeList.length) {
          this.employeeIds = [...this.$store.getters.getEmployeeList];
        } else {
          this.employeeIds = null;
        }
      },
    },
  },
};
